import { IPopupProps } from '@yandex-int/hr-components/Popup/desktop/bundle';

export const baseModifiers: IPopupProps['modifiers'] = [{
    name: 'preventOverflow',
    options: {
        padding: 16,
    },
}];
